var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.userInfo.userType=='4')?_c('salesman'):_c('channel')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }